import { instance } from '../../config/intercepter';

export const refreshAccessTokenFn = async () => {
  const response = await instance.get('api/refresh');
  return response.data;
};

export const getSideBarItemsFn = async () => {
  return await instance.get('api/sidebaritems');
};

export const signUpUserFn = async (userData) => {
  const response = await instance.post('api/register', userData);
  return response.data;
};

export const loginUserFn = async (userData) => {
  const response = await instance.post('api/login', userData, {
    // withCredentials: true,
  });
  return response.data;
}; // api/logout

export const verifyEmailFn = async (verificationCode) => {
  const response = await instance.get(`api/verifyemail/${verificationCode}`);
  return response.data;
};

export const logoutUserFn = async () => {
  const response = await instance.post('api/logout', []);
  return response.data;
};

export const getUserFn = async () => {
  const response = await instance.get('api/user');
  return response.data;
};

export const activeUserFn = async (hash) => {
  const response = await instance.get(`api/activateuser/${hash}`);
  return response.data;
};

export const forgotPasswordFn = async (username) => {
  const response = await instance.post('api/forgotpassword', { username });
  return response.data;
};

export const postResetPasswordFn = async (payload, resetCode) => {
  const response = await instance.post(
    `api/changepassword/${resetCode}`,
    payload
  );
  return response.data;
};

export const postChangePasswordFn = async (payload) => {
  const response = await instance.post(`api/changepasswordloggedin`, payload);
  return response.data;
};

export const getSideBarFn = async () => {
  const response = await instance.get('api/sidebaritems');
  return response.data;
};

export const getReportFieldsFn = async () => {
  const response = await instance.get('api/reportsfields');
  return response.data;
};

export const getNotificationFn = async () => {
  const response = await instance.get(`api/messages`);
  return response.data;
};
